import { Component, Type, ViewChild, ViewContainerRef } from '@angular/core';

import { MapMarker } from '../map.enum';
import { MarkerInfoState } from '../shared/marker-info.state';
import { SharedMarkerFactory } from '../shared/shared-marker-factory.class';
import { AggregatedMarkerComponent } from './aggregated-marker/aggregated-marker.component';
import { CommunityProjectMarkerComponent } from './community-project-marker/community-project-marker.component';
import { MarkerInfoDirective } from './marker-info.directive';
import { UserMarkerComponent } from './user-marker/user-marker.component';

@Component({
  selector: 'app-marker-info',
  template: '<ng-template marker></ng-template>',
})
export class MarkerInfoFactory extends SharedMarkerFactory {
  @ViewChild(MarkerInfoDirective, { static: true })
  public directive: MarkerInfoDirective;

  protected componentsMapper: { [key: string]: Type<MarkerInfoState> } = {
    [MapMarker.AGGREGATION_PROJECT]: AggregatedMarkerComponent,
    [MapMarker.AGGREGATION_COMMUNITY]: AggregatedMarkerComponent,
    [MapMarker.AGGREGATION_ORGANIZATION]: AggregatedMarkerComponent,
    [MapMarker.AGGREGATION_PATIENT]: AggregatedMarkerComponent,
    [MapMarker.AGGREGATION_DOCTOR]: AggregatedMarkerComponent,
    [MapMarker.AGGREGATION_MED_STAFF]: AggregatedMarkerComponent,
    [MapMarker.AGGREGATION_RESEARCHER]: AggregatedMarkerComponent,
    [MapMarker.PROJECT]: CommunityProjectMarkerComponent,
    [MapMarker.COMMUNITY]: CommunityProjectMarkerComponent,
    [MapMarker.Organization]: UserMarkerComponent,
    [MapMarker.Patient]: UserMarkerComponent,
    [MapMarker.Doctor]: UserMarkerComponent,
    [MapMarker.MedStaff]: UserMarkerComponent,
    [MapMarker.Researcher]: UserMarkerComponent,
  };

  protected getViewContainer(): ViewContainerRef {
    return this.directive.viewContainerRef;
  }
}
